/**
 * Detect whether the task pane is running inside Excel (sideload / Office host)
 * vs opened directly in a browser (manifest download / internal landing).
 */

/* global Office */

export function isRunningInExcel(): boolean {
	try {
		if (typeof Office === "undefined" || !Office.context) {
			return false
		}
		const host = Office.context.host
		// Prefer string compare so minimal Office shims (tests) don't need HostType
		if (host === "Excel") {
			return true
		}
		return typeof Office.HostType !== "undefined" && host === Office.HostType.Excel
	} catch {
		return false
	}
}
